
/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ShortlistResponse,
} from '../models';
import {
    ShortlistResponseFromJSON,
    ShortlistResponseToJSON,
} from '../models';

export interface RemoveProfileFromShortlistRequest {
    profileId: string;
}

/**
 * 
 */
export class ShortlistApi extends runtime.BaseAPI {

    /**
     * Delete current shortlist for user search
          */
    async deleteShortlistRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/search/api/shortlist`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Delete current shortlist for user search
          */
    async deleteShortlist(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteShortlistRaw(initOverrides);
    }

    /**
     * Remove profile from current shortlist
          */
    async removeProfileFromShortlistRaw(requestParameters: RemoveProfileFromShortlistRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling removeProfileFromShortlist().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/search/api/shortlist/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Remove profile from current shortlist
          */
    async removeProfileFromShortlist(requestParameters: RemoveProfileFromShortlistRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.removeProfileFromShortlistRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve shortlist for user search
          */
    async retrieveShortlistRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ShortlistResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ShortlistResponse>({
            path: `/search/api/shortlist`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ShortlistResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Retrieve shortlist for user search
          */
    async retrieveShortlist(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ShortlistResponse> {
        const response = await this.retrieveShortlistRaw(initOverrides);
        return response._data;
    }

}
